/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  SET_CAREPLAN: null,

  FETCH_CAREPLAN_LIST: null,
  FETCH_CAREPLAN_LIST_SUCCESS: null,
  FETCH_CAREPLAN_LIST_FAIL: null,

  CREATE_CAREPLAN: null,
  CREATE_CAREPLAN_SUCCESS: null,
  CREATE_CAREPLAN_FAIL: null,

  DELETE_CAREPLAN: null,
  DELETE_CAREPLAN_SUCCESS: null,
  DELETE_CAREPLAN_FAIL: null,

  GET_CAREPLAN: null,
  GET_CAREPLAN_SUCCESS: null,
  GET_CAREPLAN_FAIL: null,

  CREATE_INTERVENTION: null,
  CREATE_INTERVENTION_SUCCESS: null,
  CREATE_INTERVENTION_FAIL: null,

  CREATE_ASSESSMENT: null,
  CREATE_ASSESSMENT_SUCCESS: null,
  CREATE_ASSESSMENT_FAIL: null,

  CREATE_INSTRUCTION: null,
  CREATE_INSTRUCTION_SUCCESS: null,
  CREATE_INSTRUCTION_FAIL: null,

  UPDATE_INSTRUCTION: null,
  UPDATE_INSTRUCTION_SUCCESS: null,
  UPDATE_INSTRUCTION_FAIL: null,

  UPDATE_INTERVENTION: null,
  UPDATE_INTERVENTION_SUCCESS: null,
  UPDATE_INTERVENTION_FAIL: null,

  UPDATE_ASSESSMENT: null,
  UPDATE_ASSESSMENT_SUCCESS: null,
  UPDATE_ASSESSMENT_FAIL: null,

  IMPORT_CAREPLAN_TEMPLATE: null,
  IMPORT_CAREPLAN_TEMPLATE_SUCCESS: null,
  IMPORT_CAREPLAN_TEMPLATE_FAIL: null,

  FETCH_CAREPLAN_TEMPLATE: null,
  FETCH_CAREPLAN_TEMPLATE_SUCCESS: null,
  FETCH_CAREPLAN_TEMPLATE_FAIL: null,

  CREATE_CAREPLAN_FROM_TEMPLATE: null,
  CREATE_CAREPLAN_FROM_TEMPLATE_SUCCESS: null,
  CREATE_CAREPLAN_FROM_TEMPLATE_FAIL: null,

  SEARCH_CAREPLAN: null,
  SEARCH_CAREPLAN_SUCCESS: null,
  SEARCH_CAREPLAN_FAIL: null,

  DELETE_INTERVENTION: null,
  DELETE_INTERVENTION_SUCCESS: null,
  DELETE_INTERVENTION_FAIL: null,

  DELETE_ASSESSMENT: null,
  DELETE_ASSESSMENT_SUCCESS: null,
  DELETE_ASSESSMENT_FAIL: null,

  DELETE_INSTRUCTION: null,
  DELETE_INSTRUCTION_SUCCESS: null,
  DELETE_INSTRUCTION_FAIL: null
});
